import { useWatch } from 'react-hook-form';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import UsersContractorsListManager from '@/components/users/UsersContractorsListManager.jsx';
import { roleIsClient } from '@/constants/Roles.js';

export const ContractorInput = () => {
    const role = useWatch({ name: 'role' });
    const translate = useTranslate();
    return (
        roleIsClient(role) && (
            <Box className='padding-wrapper'>
                <Typography variant='h6' gutterBottom sx={{ marginBottom: '23px' }}>
                    {translate('resources.user.labels.assignToContractorSection')}
                </Typography>
                <UsersContractorsListManager sx={{ '& > .MuiFormHelperText-root.Mui-error': { display: 'none' } }} role={role} />
            </Box>
        )
    );
};
